export var filterBuilders = function filterBuilders(builders) {
  return builders.filter(function (builder) {
    return builder.showPhone && builder.phone && builder.phone.number;
  });
};